import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {Field, reduxForm} from "redux-form";
import MenuItem from "material-ui/MenuItem";
import Button from "react-bootstrap/lib/Button";
import toastr from "toastr";
import {SelectField, TextField} from "redux-form-material-ui";


var hasData = function (data) {

  for (var member in data) {
    if (data[member] != null)
      return false;
  }
  return true;
}
class RegularisationTable extends React.Component {

  constructor(props) {
    super(props);
    this.selectField = this.selectField.bind(this);
    this.disableCommentsField = "";
    this.state = {regStatus : "" , disableRegStatusButton : 0, displayClearButton : "inline", disableTextField : 0 }
  }

    componentWillReceiveProps(newProps)
    {
        let regStatus = newProps.regularization.regStatus;
        if(newProps.regularization.regularisationStatus === "PROCESSED") {
            this.setState({regStatus: "Leave Deduction Processed", disableRegStatusButton : 1,
                displayClearButton: "none", disableTextField : 1 });
            this.disableCommentsField = "disabled";
        } else {

            switch (regStatus) {

                case "pending" :
                    this.setState({regStatus: "Apply", displayClearButton : "inline", disableTextField : 0,
                        disableRegStatusButton : 0});
                    this.disableCommentsField = "";
                    break;
                case "apply" :
                    this.setState({regStatus: "Applied", disableRegStatusButton: 1,
                        displayClearButton: "none", disableTextField : 1 });
                    this.disableCommentsField = "disabled";
                    break;
                case "approved" :
                    this.setState({regStatus: regStatus.charAt(0).toUpperCase() + regStatus.slice(1), disableRegStatusButton : 1,
                        displayClearButton: "none", disableTextField : 1 });
                    this.disableCommentsField = "disabled";
                    break;
                case "rejected" :
                    this.setState({regStatus: regStatus.charAt(0).toUpperCase() + regStatus.slice(1), disableRegStatusButton : 1,
                        displayClearButton: "none", disableTextField : 1 });
                    this.disableCommentsField = "disabled";
                    break;
                case "re-regularize" :
                    this.setState({regStatus: regStatus.charAt(0).toUpperCase() + regStatus.slice(1), displayClearButton : "inline",
                        disableTextField : 0, disableRegStatusButton : 0});
                    this.disableCommentsField = "";
                    break;
            }
        }
    }

    componentDidMount() {
        let regStatus = this.props.regularization.regStatus;
        if(this.props.regularization.regularisationStatus === "PROCESSED") {
            this.setState({regStatus: "Leave Deduction Processed", disableRegStatusButton : 1,
                displayClearButton: "none", disableTextField : 1 });
            this.disableCommentsField = "disabled";
        } else {

            switch (regStatus) {

                case "pending" :
                    this.setState({regStatus: "Apply", displayClearButton : "inline", disableTextField : 0,
                        disableRegStatusButton : 0});
                    this.disableCommentsField = "";
                    break;
                case "apply" :
                    this.setState({regStatus: "Applied", disableRegStatusButton: 1,
                        displayClearButton: "none", disableTextField : 1 });
                    this.disableCommentsField = "disabled";
                    break;
                case "approved" :
                    this.setState({regStatus: regStatus.charAt(0).toUpperCase() + regStatus.slice(1), disableRegStatusButton : 1,
                        displayClearButton: "none", disableTextField : 1 });
                    this.disableCommentsField = "disabled";
                    break;
                case "rejected" :
                    this.setState({regStatus: regStatus.charAt(0).toUpperCase() + regStatus.slice(1), disableRegStatusButton : 1,
                        displayClearButton: "none", disableTextField : 1 });
                    this.disableCommentsField = "disabled";
                    break;
                case "re-regularize" :
                    this.setState({regStatus: regStatus.charAt(0).toUpperCase() + regStatus.slice(1), displayClearButton : "inline",
                        disableTextField : 0, disableRegStatusButton : 0});
                    this.disableCommentsField = "";
                    break;
            }
        }
    }

  selectField(cell, row, formatExtraData, rowIdx) {

    return <Field
      hintText="Select Reason"
      style={{width: '100%', fontSize: '15px'}}
      labelStyle={{color: "#0FCAAA", 'font-size': '15'}}
      disabled = { this.state.disableTextField }
      menuStyle={{
        'width': '100%',
        "font-family": '"ProximaNova-Regular", "sans-serif"',
        fontSize: '15px',
        fontColor: 'blue'
      }}
      width={'90%'} name={"regularizedReason" + rowIdx} component={SelectField} label="Regularization Reason">
      <MenuItem value={null} primaryText="&nbsp;"/>
      <MenuItem value={"out of office duty"} primaryText="Out of office duty"/>
      <MenuItem value={"swipe issue"} primaryText="Swipe Issue"/>
      <MenuItem value={"forgot to carry id card"} primaryText="Forgot to carry Id card"/>
      <MenuItem value={"weekly off"} primaryText="Weekly off"/>

    </Field>;
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }

  textField(cell, row, formatExtraData, rowIdx) {
    return <Field name={"comments" + rowIdx} component={TextField}
                  style={{width: "100%"}}
                  hintText="Enter comments if any"
                  multiLine={true}
                  disabled = {this.disableCommentsField}
                  rows={1}
                  rowsMax={4}/>;
  }


  render() {
    const {handleSubmit, pristine, reset, submitting} = this.props;
    let name = this.props.name;
    return (
      <div>

        <form
          onSubmit={handleSubmit((data)=> {
            let request = {};
            if (Object.getOwnPropertyNames(data).length == 0 || hasData(data)) {
              toastr.error("Kindly Specify either weekly comment, daily comment, or daily regularised reason");
              return;
            }
            request.comment = data.comment ? data.comment : "";
            request.id = this.props.regularization.id;
            request.applicantId = this.props.regularization.applicantId;
            request.regularization = new Array();
            this.props.regularization.regularization.map((node, index)=> {

              request.regularization[index] = {};
              request.regularization[index].attendanceDate = node.attendanceDate;
              request.regularization[index].applicantComment = data["comments" + index] ? data["comments" + index] : "";
              request.regularization[index].regularizedReason = data["regularizedReason" + index] ? data["regularizedReason" + index] : null;

            });
            this.props.applyRegularisation(request);
            reset();
          })}>
          <div style={{
            borderBottomStyle: 'solid',
            borderWidth: '1px',
            borderColor: 'rgb(92, 184, 92)'

          }}>
            <BootstrapTable containerStyle={{
              borderColor: '#616161',
              borderRadius: '5px', padding: '0px'
            }} data={[this.props.regularization]}>
              <TableHeaderColumn
                className="rowX"
                style={{color: 'red', paddingColor: 'red'}}
                isKey={true} dataField="startDate" width={120}>Start Date</TableHeaderColumn>
              <TableHeaderColumn dataField="endDate"
                                 width={100}>End Date</TableHeaderColumn>
              <TableHeaderColumn dataField="manHours"
                                 dataFormat={this.checkNull}
                                 width={150}>Weekly Hrs</TableHeaderColumn>
              <TableHeaderColumn dataField="managerRemark" width={200}
                                 dataFormat={(cell, row)=> {
                                   if (cell == null || cell == undefined || cell == "") {
                                     return 'NA';
                                   }
                                   return <label style={{
                                     'fontSize': '14px',
                                     'white-space': 'normal',
                                     'overflow-wrap': 'break-word',
                                     paddingTop: 0,
                                     paddingLeft: 0,
                                     paddingBottom: 0
                                   }}>{cell}</label>;
                                 }}>Manager Remark </TableHeaderColumn>
              <TableHeaderColumn columnClassName="rowX" className="rowX" dataField="comment" dataFormat={()=> {
                return <div>
                  <Field name={"comment"} component={TextField}
                         style={{width: "100%", marginTop: 0}}
                         hintText="Enter comments if any"
                         disabled = {this.state.disableTextField}
                         multiLine={true} rows={1} rowsMax={4}/>

                </div>;
              }}>Comments</TableHeaderColumn>

            </BootstrapTable>
          </div>
          <BootstrapTable data={this.props.regularization.regularization} striped={false} hover={true} condensed={true}>
            <TableHeaderColumn dataSort={false}
                               columnClassName="rowX"
                               isKey={true} width={120} dataField="attendanceDate">Date</TableHeaderColumn>
            <TableHeaderColumn dataSort={false}

                               columnClassName="rowX"
                               dataFormat={this.checkNull}
                               width={100}
                               dataField="systemInTime">In Time</TableHeaderColumn>
            <TableHeaderColumn dataSort={false}
                               columnClassName="rowX"
                               dataFormat={this.checkNull}
                               width={100} dataField="systemOutTime">Out Time</TableHeaderColumn>
            <TableHeaderColumn
              columnClassName="rowX"
              dataField="regularizedReason" dataFormat={this.selectField}>Reason</TableHeaderColumn>
            <TableHeaderColumn
              columnClassName="rowX"
              dataField="applicantComment" dataFormat={this.textField}>Comments</TableHeaderColumn>
            <TableHeaderColumn
              columnClassName="rowX"
              dataField="remark" dataFormat={this.checkNull}>Manager Remark</TableHeaderColumn>
          </BootstrapTable>
          <Button style={{width: '100px', display: this.state.displayClearButton }} onClick={()=> {
            reset();
          }
          }>Clear</Button>
          <Button style={{width: '200px', marginLeft: '20px'}} type="submit" disabled = {this.state.disableRegStatusButton} >
              {this.state.regStatus}</Button>
        </form>
      </div>
    );
  }
}

RegularisationTable.propTypes = {};

export default reduxForm({
  form: "table2"


})(RegularisationTable)




/** WEBPACK FOOTER **
 ** ./src/feature/attendance/MyAttendance/ReactTable/RegularisationTable2.js
 **/